export default __webpack_public_path__ + "static/media/starIcon.b0584c5e.svg";